import * as actionTypes from 'redux/actions'

const initialState = {
  loggedIn: false,
  isCollapsedMenu: false,
  pendingAccountIDs: [],
  pendingCampaignIDs: []
}

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      return {
        ...state,
        ...action.payload,
        loggedIn: action.payload.state || action.payload.is_success
      }
    }
    case actionTypes.GET_ACCOUNT: {
      return {
        ...state,
        user: action.payload
      }
    }

    case actionTypes.SESSION_LOGOUT: {
      return {
        loggedIn: false
      }
    }

    case actionTypes.TOGGLE_COLLAPSE_MENU: {
      return { ...state, isCollapsedMenu: !state.isCollapsedMenu }
    }

    case actionTypes.SET_PENDING_ACCOUNT_IDS: {
      return { ...state, pendingAccountIDs: action.payload }
    }

    case actionTypes.SET_PENDING_CAMPAIGN_IDS: {
      return { ...state, pendingCampaignIDs: action.payload }
    }

    default: {
      return state
    }
  }
}

export default sessionReducer
